<div class="page-header">
    <h6 class="page-titles" style="cursor:context-menu;">
        <span class="page-title-icons bg-gradient-primary text-white mr-2">
            <i class="mdi mdi-clipboard-account menu-icon"></i>
        </span> ติดต่อกองทุนจัดรูปที่ดินเพื่อพัฒนาพื้นที่
    </h6>
</div>
<div class="row">
	<div class="col-12 grid-margin">
		<div>
			<div class="row">
				<div class="col-md-12">
					<div class="row">

						<div class="col-lg-6 col-md-6 col-sm-12">
							<iframe
								src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7750.772477297071!2d100.5736210092532!3d13.75556621813917!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29e8ac1b093c3%3A0xae8d6463953746fd!2sDepartment%20of%20Public%20Works%20and%20Town%20%26%20Country%20Planning!5e0!3m2!1sen!2sth!4v1601537717691!5m2!1sen!2sth"
								width="100%" height="700" frameborder="0" style="border:0;"
								allowfullscreen="" aria-hidden="false" tabindex="0"></iframe>
						</div>
						<div class="col-lg-6 col-md-6 col-sm-12">
							<h4 class="text-center" style="vertical-align: middle;">
								สำนักงานกองทุนจัดรูปที่ดินเพื่อพัฒนาพื้นที่ 224 <br> กรมโยธาธิการและผังเมือง
								<br>
								ถนนพระราม 9 แขวงห้วยขวาง เขตห้วยขวาง <br> กรุงเทพมหานคร 10310 <br>
							</h4>

							<table class="table table-responsive">
								<tr>
									<td style="vertical-align: middle;">โทรศัพท์ : </td>
									<td style="vertical-align: middle;">
										<h4 style="margin-bottom: 0px;">0 2201 8059, 0 2201 8060</h4>
									</td>
								</tr>
								<tr>
									<td style="vertical-align: middle;">โทรสาร : </td>
									<td style="vertical-align: middle;">
										<h4 style="margin-bottom: 0px;">0 2201 8062</h4>
									</td>
								</tr>
								<tr>
									<td style="vertical-align: middle;"> E-mail : </td>
									<td style="vertical-align: middle;">
										<h4>lrfund@outlook.com</h4>
										<h4 style="margin-bottom: 0px;">lrfund@dpt.mail.go.th</h4>
									</td>
								</tr>
								<tr>
									<td style="vertical-align: middle;">Line : </td>
									<td style="vertical-align: middle;">
										<h4 style="margin-bottom: 0px;">@nao6424e</h4>
									</td>
								</tr>
								<tr>
									<td style="vertical-align: middle;"> Website : </td>
									<td style="vertical-align: middle;">
										<h4 style="margin-bottom: 0px;"><a href="http://office.dpt.go.th/lrfund/"
												target="_blank">http://office.dpt.go.th/lrfund/</a></h4>
									</td>
								</tr>
								<tr>
									<td style="vertical-align: middle;">Facebook : </td>
									<td style="vertical-align: middle;">
										<h4 style="margin-bottom: 0px;"> <a href="https://www.facebook.com/lrfund"
												target="_blank">www.facebook.com/lrfund</a> </h4>
									</td>
								</tr>
							</table>
							<img src="http://office.dpt.go.th/lrfund/images/Map/contact_map03.jpg"
								alt="" width="100%">
						</div>

					</div>
				</div>
			</div>
		</div>
	</div>
</div>